/* MIKOO: shows the unframed product picture inside the frame the shopper picks.
   Frame sizes are the real ones from the frames page: wood 1.5 cm front and 3 cm deep,
   aluminium 0.7 cm front and 2.5 cm deep. Colours were sampled from the real frame photos. */
(function () {
  var WOOD = { profile: 1.5, depth: 3 };
  var METAL = { profile: 0.7, depth: 2.5 };
  var FRAMES = {
    'עץ שחור': { dims: WOOD, base: '#121214', light: '#2a2a30', dark: '#060607', side: '#000000' },
    'עץ טבעי': { dims: WOOD, base: '#e6c88f', light: '#f3dcae', dark: '#d4b48b', side: '#b89868', tex: 'natural' },
    'עץ מולבן': { dims: WOOD, base: '#f1e8d9', light: '#f8efe0', dark: '#e6dccb', side: '#cfc4b1', tex: 'whitewashed' },
    'עץ אלון': { dims: WOOD, base: '#bfa074', light: '#dcc092', dark: '#a98a5c', side: '#8c7048', tex: 'oak' },
    'אלומיניום שחור': { dims: METAL, base: '#0c0c0e', light: '#303034', dark: '#020203', side: '#000000' },
    'אלומיניום לבן': { dims: METAL, base: '#efefef', light: '#fafafa', dark: '#e0e0e0', side: '#c4c4c4' }
  };
  var NO_FRAME = 'ללא מסגרת';
  var plainImages = [];
  /* shared with the wall preview (mikoo-wall-preview.js), so both draw the same frames */
  window.MikooFrame = { frames: FRAMES, noFrame: NO_FRAME };

  /* #rrggbb -> rgba(r, g, b, alpha) */
  function transparent(hex, alpha) {
    var n = parseInt(hex.slice(1), 16);
    return 'rgba(' + ((n >> 16) & 255) + ', ' + ((n >> 8) & 255) + ', ' + (n & 255) + ', ' + alpha + ')';
  }

  function productHandle() {
    var part = location.pathname.split('/products/')[1];
    return part ? part.split('/')[0] : null;
  }

  /* The unframed pictures, from the product's image file names. Usually they end in 1 (framed: 2, room: 3).
     Before comparing, Shopify's _<uuid> and _<n> suffixes for repeated names are removed (a uuid can end in 1).
     When the product has a framed picture ("…2"), only the "…1" with the same name counts (so a room picture
     like "…no131" next to "…no11" / "…no12" is left out). Old uploads with no number: the unframed picture is
     named like the framed one without the 2. Same rule as snippets/mikoo-frame-stage.liquid.
     isPlain(src, all): all = every image of the product (srcs or objects with .src). */
  function stemOf(src) {
    var m = /([^/]+)[.](jpe?g|png|webp)$/i.exec(String(src || '').split('?')[0]);
    return m ? m[1].replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '').replace(/_[0-9]+$/, '') : null;
  }
  function plainStems(all) {
    var stems = (all || []).map(function (x) { return stemOf(typeof x === 'string' ? x : x && (x.src || x.url)); }).filter(Boolean);
    var ones = stems.filter(function (s) { return /1$/.test(s); });
    var bases = stems.filter(function (s) { return /2$/.test(s); }).map(function (s) { return s.slice(0, -1); });
    var matched = ones.filter(function (s) { return bases.indexOf(s.slice(0, -1)) > -1; });
    if (matched.length) return matched;
    if (ones.length) return ones;
    return stems.filter(function (s) { return !/[0-9]$/.test(s) && stems.indexOf(s + '2') > -1; });
  }
  function isPlain(src, all) {
    var stem = stemOf(src);
    return !!stem && plainStems(all && all.length ? all : [src]).indexOf(stem) > -1;
  }

  function selectedValues() {
    var root = document.querySelector('variant-selects');
    var values = [];
    if (!root) return values;
    root.querySelectorAll('input[type="radio"]:checked').forEach(function (input) { values.push(input.value); });
    root.querySelectorAll('select').forEach(function (select) { values.push(select.value); });
    return values;
  }

  function currentFrame(values) {
    for (var i = 0; i < values.length; i++) {
      if (FRAMES[values[i]]) return values[i];
      if (values[i].indexOf(NO_FRAME) > -1) return 'none';
    }
    return null;
  }

  /* picture width in cm, read from a size value such as 30x40 */
  /* landscape: sizes are written width first for portrait pictures, so a landscape picture's width is the larger number */
  function currentWidthCm(values, landscape) {
    for (var i = 0; i < values.length; i++) {
      var match = /^([0-9]+) *[xX] *([0-9]+)$/.exec(values[i].trim());
      if (match) {
        var a = parseInt(match[1], 10);
        var b = parseInt(match[2], 10);
        return landscape ? Math.max(a, b) : Math.min(a, b);
      }
    }
    return 30;
  }

  /* container query units: border and depth follow the frame width in CSS (mikoo-product.css) */
  var CQ = !!(window.CSS && CSS.supports && CSS.supports('width', '1cqw'));

  /* frame width in % of the row, same as mikoo-frame-stage.liquid: 1 picture 62, 2 → 44, up to 3 in a row, more in two rows */
  function frameWidth(count) {
    var perRow = count > 3 ? Math.floor((count + 1) / 2) : count;
    if (perRow <= 1) return 62;
    if (perRow === 2) return 44;
    return Math.floor((100 - 6 * (perRow - 1)) / perRow);
  }

  /* Mixed-size sets (no size option): the picture list "NAME - 50x70 … צבע מסגרת - …" (rendered by
     mikoo-wall-preview.liquid) gives each picture its size. Each frame is matched to its line by file name,
     as in mikoo-wall-preview.js readList(), then drawn to scale (--mk-scale) with its size under it.
     Returns one {widthCm} per frame, or null when the product has a size option or no usable list. */
  var mixedCache = null;
  function mixedSizes(stage, values, profile) {
    var frames = Array.prototype.slice.call(stage.querySelectorAll('.mk-frame'));
    for (var c = 0; c < values.length; c++) {
      if (values[c].indexOf('+') < 0 || frames.length < 2) continue;
      var ratios = frames.map(function (f) { var img = f.querySelector('img'); return img ? (+img.getAttribute('width') || 3) / (+img.getAttribute('height') || 4) : 0.75; });
      var combo = comboSizes(values[c], ratios);
      if (combo) return scaleFrames(stage, frames, combo, true, profile);
    }
    for (var v = 0; v < values.length; v++) if (/^[0-9]+ *[xX] *[0-9]+$/.test(values[v].trim())) return null;
    if (frames.length < 2) return null;
    if (mixedCache && mixedCache.length === frames.length) return mixedCache;
    var el = document.querySelector('[data-mk-wp-list]');
    var html = '';
    try { html = el ? JSON.parse(el.textContent) || '' : ''; } catch (e) { return null; }
    var text = html.replace(/<\/p>|<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
      .replace(/\n\s*(?=-\s*[0-9]+\s*[xX×])/g, ' ');
    var items = [];
    text.split('\n').forEach(function (raw) {
      var m = /^(.*?)\s*-\s*([0-9]+)\s*[xX×]\s*([0-9]+)\s*$/.exec(raw.trim());
      if (m) items.push({ name: m[1], w: +m[2], h: +m[3], used: false });
    });
    if (items.length < 2) return null;
    var distinct = items.some(function (it) { return it.w !== items[0].w || it.h !== items[0].h; });
    if (!distinct) return null;

    function key(s) { return s.toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function fileKey(src) {
      var file = (src || '').split('?')[0].split('/').pop().replace(/[.][a-z]+$/i, '').replace(/_[0-9a-f]{8}-[0-9a-f-]+$/i, '');
      return key(file.replace(/1$/, ''));
    }
    function pairs(s) { var out = []; for (var i = 0; i < s.length - 1; i++) out.push(s.substr(i, 2)); return out; }
    function similar(a, b) {
      if (!a || !b) return 0;
      if (a === b) return 2;
      if (a.indexOf(b) > -1 || b.indexOf(a) > -1) return 1.5;
      var A = pairs(a), B = pairs(b).slice(), hits = 0;
      A.forEach(function (g) { var j = B.indexOf(g); if (j > -1) { hits++; B.splice(j, 1); } });
      return (2 * hits) / (A.length + B.length + hits || 1);
    }
    var srcs = frames.map(function (f) { var img = f.querySelector('img'); return img ? (img.currentSrc || img.src) : ''; });
    var scores = [];
    items.forEach(function (it, i) {
      srcs.forEach(function (src, j) { var s = similar(key(it.name), fileKey(src)); if (s >= 0.55) scores.push({ i: i, j: j, s: s }); });
    });
    scores.sort(function (a, b) { return b.s - a.s; });
    var byFrame = [];
    scores.forEach(function (sc) {
      if (items[sc.i].used || byFrame[sc.j]) return;
      items[sc.i].used = true;
      byFrame[sc.j] = items[sc.i];
    });
    var spare = items.filter(function (it) { return !it.used; });
    frames.forEach(function (f, j) { if (!byFrame[j] && spare.length) byFrame[j] = spare.shift(); });
    if (byFrame.length !== frames.length || byFrame.some(function (it) { return !it; })) return null;
    mixedCache = scaleFrames(stage, frames, byFrame);
    return mixedCache;
  }

  /* A set whose pictures differ in shape sells in size pairs such as "70x70 + 50x70" (owner, 2026-10-29: the square
     stays square, as tall as the portrait beside it). Each picture takes the listed size closest to its own shape.
     ratios: width / height of each picture. Null when the value is not such a list. Same rule in
     mikoo-product-extras.js, mikoo-wall-preview.js and mikoo-cart.js. */
  function comboSizes(value, ratios) {
    var parts = String(value || '').split('+');
    if (parts.length < 2) return null;
    var sizes = [];
    for (var i = 0; i < parts.length; i++) {
      var m = /^\s*([0-9]+)\s*[xX×]\s*([0-9]+)\s*$/.exec(parts[i]);
      if (!m) return null;
      sizes.push({ w: +m[1], h: +m[2], used: false });
    }
    return ratios.map(function (r) {
      var best = null;
      sizes.forEach(function (s) {
        var d = Math.abs(Math.log(r / (s.w / s.h)));
        if (!s.used && (!best || d < best.d)) best = { s: s, d: d };
      });
      if (!best) return { w: sizes[0].w, h: sizes[0].h };
      best.s.used = true;
      return { w: best.s.w, h: best.s.h };
    });
  }

  /* draws each frame to scale from its own size ({w, h} per frame) and writes the size under it */
  /* exact (size pairs): each picture is shown in its size's own shape (cropped like the print) and the frames are
     scaled by their outer width, so pictures of the same height line up exactly; profile = frame front in cm */
  function scaleFrames(stage, frames, byFrame, exact, profile) {
    /* frame width follows the picture's real width. Up to 5 pictures hang in one row, more in two rows split
       where the two widths are closest; the row is filled (6% gaps), the largest frame at most 62% */
    var lands = frames.map(function (f) {
      var img = f.querySelector('img');
      return !!(img && +img.getAttribute('width') > +img.getAttribute('height') * 1.05);
    });
    var widths = frames.map(function (f, j) {
      var it = byFrame[j];
      return lands[j] ? Math.max(it.w, it.h) : Math.min(it.w, it.h);
    });
    var outer = widths.map(function (w) { return exact ? w + 2 * (profile || 0) : w; });
    var max = Math.max.apply(null, outer);
    var ratios = outer.map(function (w) { return w / max; });
    var sum = function (a) { return a.reduce(function (x, y) { return x + y; }, 0); };
    var fw = frameWidth(frames.length);
    var split = frames.length;
    if (frames.length > 5) {
      var best = Infinity;
      for (var k = 1; k < frames.length; k++) {
        var diff = Math.abs(sum(ratios.slice(0, k)) - sum(ratios.slice(k)));
        if (diff < best) { best = diff; split = k; }
      }
    }
    var rowsFit = [ratios.slice(0, split), ratios.slice(split)].filter(function (r) { return r.length; }).map(function (r) {
      return (100 - 6 * (r.length - 1)) / (sum(r) * fw);
    });
    var base = Math.min(Math.min.apply(null, rowsFit) * 0.96, 62 / fw);
    if (split < frames.length && !stage.querySelector('.mk-stage__break')) {
      var br = document.createElement('span');
      br.className = 'mk-stage__break';
      br.setAttribute('aria-hidden', 'true');
      frames[split].parentNode.insertBefore(br, frames[split]);
    }
    frames.forEach(function (f, j) {
      f.style.setProperty('--mk-scale', (ratios[j] * base).toFixed(3));
      f.setAttribute('data-mk-size', byFrame[j].w + '×' + byFrame[j].h);
      if (exact) {
        var it = byFrame[j], h = lands[j] ? Math.min(it.w, it.h) : Math.max(it.w, it.h);
        f.style.setProperty('--mk-pic-ratio', (widths[j] / h).toFixed(4));
        f.setAttribute('data-mk-exact', '');
      }
    });
    stage.classList.add('mk-stage--sized');
    return widths.map(function (w) { return { widthCm: w }; });
  }

  function firstMediaItem() {
    return document.querySelector('.product__media-list .product__media-item');
  }

  function build() {
    var item = firstMediaItem();
    if (!item) return null;
    var stage = item.querySelector('.mk-stage');
    if (stage) return stage;
    if (!plainImages.length) return null;

    stage = document.createElement('div');
    stage.className = 'mk-stage';
    var row = document.createElement('div');
    row.className = 'mk-stage__row' + (plainImages.length > 1 ? ' mk-stage__row--multi' : '');
    var fw = frameWidth(plainImages.length);
    row.style.setProperty('--mk-fw', fw + '%');
    row.style.setProperty('--mk-fwc', fw + 'cqw');
    var count = plainImages.length;
    var fwSmall = count <= 1 ? 50 : count === 2 ? 40 : count === 4 ? 30 : 26;
    row.style.setProperty('--mk-fw-s', fwSmall + '%');
    row.style.setProperty('--mk-fwc-s', fwSmall + 'cqw');
    plainImages.forEach(function (media) {
      var src = media.src;
      var frame = document.createElement('div');
      frame.className = 'mk-frame';
      var pic = document.createElement('span');
      pic.className = 'mk-frame__pic';
      var img = new Image();
      img.alt = '';
      // real size up front, so the stage keeps its height while the picture loads (no layout jump)
      if (media.width && media.height) { img.width = media.width; img.height = media.height; }
      img.fetchPriority = 'high';
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
      pic.appendChild(img);
      frame.appendChild(pic);
      row.appendChild(frame);
    });
    var caption = document.createElement('p');
    caption.className = 'mk-stage__caption';
    stage.appendChild(row);
    stage.appendChild(caption);
    item.classList.add('mk-has-stage');
    item.appendChild(stage);
    if (!CQ && window.ResizeObserver) {
      new ResizeObserver(function () { apply(false); }).observe(stage);
    }
    return stage;
  }

  function apply(showFirst) {
    var stage = build();
    if (!stage) return;
    var values = selectedValues();
    /* mixed-size sets have no frame option; the frame comes from their picture list (set in mikoo-frame-stage.liquid) */
    var name = currentFrame(values) || stage.getAttribute('data-mk-list-frame') || null;
    var def = FRAMES[name];
    var firstImg = stage.querySelector('img');
    var landscape = !!(firstImg && +firstImg.getAttribute('width') > +firstImg.getAttribute('height') * 1.05);
    var widthCm = currentWidthCm(values, landscape);
    var mixed = mixedSizes(stage, values, def ? def.dims.profile : 0);

    stage.querySelectorAll('.mk-frame').forEach(function (frame, i) {
      var cm = mixed ? mixed[i].widthCm : widthCm;
      /* real wood grain (assets/mikoo-frame-<tex>.jpg as a border image, mikoo-product.css); the flat colours stay underneath until it loads */
      if (def && def.tex) frame.setAttribute('data-mk-tex', def.tex);
      else frame.removeAttribute('data-mk-tex');
      if (CQ) {
        frame.classList.toggle('mk-frame--bare', !def);
        if (def) {
          var outerCm = cm + 2 * def.dims.profile;
          frame.style.setProperty('--mk-b', (def.dims.profile / outerCm).toFixed(4));
          frame.style.setProperty('--mk-d', (def.dims.depth / outerCm).toFixed(4));
          frame.style.setProperty('--mk-bmin', '2px');
          frame.style.setProperty('--mk-c-light', def.light);
          frame.style.setProperty('--mk-c-dark', def.dark);
          frame.style.setProperty('--mk-c-base', def.base);
          frame.style.setProperty('--mk-c-side', transparent(def.side, 0.35));
        }
        return;
      }
      var outer = frame.getBoundingClientRect().width;
      if (!outer) return;
      if (def) {
        var pxPerCm = outer / (cm + 2 * def.dims.profile);
        var border = Math.max(2, pxPerCm * def.dims.profile);
        var depth = pxPerCm * def.dims.depth;
        frame.style.borderWidth = border.toFixed(1) + 'px';
        frame.style.borderColor = [def.light, def.dark, def.dark, def.base].join(' ');
        /* same size as the original shadow, but see-through: the side edge and the drop shadow are both transparent */
        frame.style.boxShadow =
          (depth * 0.14).toFixed(1) + 'px ' + (depth * 0.14).toFixed(1) + 'px 0 0 ' + transparent(def.side, 0.35) + ', ' +
          (depth * 0.5).toFixed(1) + 'px ' + (depth * 0.65).toFixed(1) + 'px ' + (depth * 1.1).toFixed(1) + 'px rgba(0, 0, 0, 0.12)';
        frame.style.setProperty('--mk-recess', (depth * 0.1).toFixed(1) + 'px');
      } else {
        frame.style.borderWidth = '0px';
        frame.style.borderColor = 'transparent';
        frame.style.boxShadow = '';
        frame.style.setProperty('--mk-recess', '0px');
      }
    });

    var caption = stage.querySelector('.mk-stage__caption');
    if (def) {
      caption.textContent = 'הדמיה: מסגרת ' + name + ', רוחב ' + def.dims.profile + ' ס״מ, עומק ' + def.dims.depth + ' ס״מ';
    } else if (name === 'none') {
      caption.textContent = 'הדפסה בלבד, ללא מסגרת';
    } else {
      caption.textContent = '';
    }

    if (showFirst) {
      try {
        var item = firstMediaItem();
        var gallery = document.querySelector('media-gallery');
        if (!item) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          /* phones: bring the preview slide into the gallery without moving the page (Dawn's setActiveMedia
             scrolls the page up to the picture, away from the buttons; the small floating copy shows the change) */
          var list = item.parentElement;
          if (list && list.scrollTo) list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'auto' });
        } else if (gallery && gallery.setActiveMedia && item.dataset.mediaId) {
          gallery.setActiveMedia(item.dataset.mediaId, false);
        }
      } catch (e) {}
    }
  }

  function listen() {
    apply(false);

    document.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('variant-selects')) return;
      apply(true);
      window.setTimeout(function () { apply(false); }, 700);
    });

    var section = document.querySelector('.product') || document.body;
    new MutationObserver(function () {
      var item = firstMediaItem();
      if (item && !item.querySelector('.mk-stage')) apply(false);
    }).observe(section, { childList: true, subtree: true });
  }

  function init() {
    var handle = productHandle();
    if (!handle) return;
    var ready = document.querySelector('.mk-stage[data-mk-ssr]');
    fetch('/products/' + handle + '.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        /* still needed if Dawn moves another picture to the front and the stage has to be built there */
        plainImages = (product.media || [])
          .filter(function (media, i, all) { return media.media_type === 'image' && isPlain(media.src, all); })
          .map(function (media) { return { src: media.src, width: media.width, height: media.height }; });
        if (!ready && plainImages.length) listen();
      })
      .catch(function () {});
    if (ready) listen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
